import COM from './Toggle'

export default COM
